package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_06_02_Day_1
import com.veldekar.components.logs.Log_2023_06_02_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-06-02")
@Composable
public fun Log_2023_06_02(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Treasure and Tunnels",
        ogTitle = "Treasure and Tunnels",
        date = LocalDate(2_023, 6, 2),
        ogDescription = "After clearing the outpost of demons, the heroes discover a massive hoard of gold and powerful magical artifacts.",
        ogImage = "ai/2023-06-02.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
        Log_2023_06_02_Day_1()
        SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
        Log_2023_06_02_Day_2()
    }
}
